module.exports = __webpack_public_path__ + "static/img/c.ac032c6d.gif";